import { toFixed } from '../../../core/services/utils/numbers';

/** Calcula o valor potencial multiplicando a quantidade pelo valor unitário */
export function calcularValorPotencial(quantidadePotencial: number, valorUnitario: number, precision = 4): number {
    quantidadePotencial = quantidadePotencial && !isNaN(quantidadePotencial) ? Number(quantidadePotencial) : 0;
    valorUnitario = valorUnitario && !isNaN(valorUnitario) ? Number(valorUnitario) : 0;

    const valorPotencial = quantidadePotencial * valorUnitario;
    return toFixed(valorPotencial, precision);
}
